/** @format */
import { BasketProduct } from '@toucan/client/core/basket';

export enum BasketItemAvailability {
    AVAILABLE = 'Available',
    UNAVAILABLE = 'Unavailable',
}

// Touch and Change
// eslint-disable-next-line @typescript-eslint/consistent-type-definitions
export interface BasketItem {
    product: BasketProduct;
    availability: BasketItemAvailability;
    itemImage: {
        '36x36': string;
        '200x200': string;
        '1000x800': string;
    };
    sku: string;
    department: string;
    listPrice: string;
    currency: string;
    taxScheme: string[];
    /**
     * @deprecated
     * We shouldn't use this as the basket service uses legacy tax calculations
     */
    priceExTax?: string;
    /**
     * @deprecated
     * We shouldn't use this as the basket service uses legacy tax calculations
     */
    priceIncTax?: string;
}

// Touch and Change
// eslint-disable-next-line @typescript-eslint/consistent-type-definitions
export interface Basket {
    items: BasketItem[];
    codes?: string[];
    currency?: string;
}
